<template>
  <div>
    <!-- 菜单权限管理 -->
    <div class="filter-container">
      <!-- 查找参数区 -->
      <el-form :model="filter" :inline="true">
        <el-form-item label="所属单位">
          <el-select v-model="filter.entityId" placeholder="单位名称" style="width:100%" @change="entityChange">
            <el-option v-for="item in entityIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="filter.roleId" placeholder="角色" style="width:100%">
            <el-option v-for="item in roleIdOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button circle plain type="primary" icon="el-icon-search" @click="handleFilter" title="搜索">
          </el-button>
          <el-button circle plain type="info" icon="el-icon-s-unfold" @click="expandOrNot(true)" title="展开菜单">
          </el-button>
          <el-button circle plain type="warning" icon="el-icon-s-fold" @click="expandOrNot(false)" title="折叠菜单">
          </el-button>
          <el-button circle plain type="success" icon="el-icon-check" @click="handleSubmit" title="授权"></el-button>
          <el-button circle plain type="info" icon="el-icon-refresh" @click="handleInit" title="刷新"></el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="menu-tree">
      <!-- <p>使用 scoped slot</p> -->
      <el-tree v-loading="menu_tree_loading" :data="menu_data" show-checkbox :check-strictly="true" node-key="id"
        :default-expand-all="false" draggable ref="treeX" :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
  import {
    getRoles,
    getMenusByRoleId,
    updateRoleMenu
  } from '@/api/role.js'
  import {
    allMenuItem
  } from '@/api/menu'

  export default {
    name: 'MenuRoleManage',
    data() {
      return {
        entityIdOptions: [],
        roleIdOptions: [],
        filter: {
          entityId: undefined,
          roleId: undefined,
        },
        menu_data: [],
        menu_tree_loading: true,
      }
    },
    methods: {
      initEntityOptions() {
        if (this.entityIdOptions.length === 0) {
          let entitys = JSON.parse(localStorage.entity)
          for (let k in entitys) {
            this.entityIdOptions.push({
              value: k,
              label: entitys[k]
            })
          }
        }
      },
      initMenuTree() {
        this.menu_tree_loading = true
        allMenuItem(this.$store.getters['user/roleId']).then(res => {
          if (res.result === "0") {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.dialogNewVisible = false
          } else {
            this.$message.error(res.message)
          }
          this.menu_data = this.menuDataTrans(res.menu).children
          this.menu_tree_loading = false
        })
      },
      menuDataTrans(item) {
        let res = {
          icon: item.cur.icon,
          id: item.cur.id,
          label: item.cur.name,
          parentid: item.cur.parentid,
          url: item.cur.url,
          children: []
        }
        for (let child of item.children) {
          res.children.push(this.menuDataTrans(child))
        }
        return res
      },
      expandOrNot(isexpand) {
        for (var i = 0; i < this.$refs.treeX.store._getAllNodes().length; i++) {
          this.$refs.treeX.store._getAllNodes()[i].expanded = isexpand;
        }
      },
      entityChange(entityId) {
        this.filter.roleId = undefined //取消上次选择角色
        getRoles(entityId).then(res => {
          let roles = res.data;
          this.roleIdOptions = roles.map(item => {
            return {
              value: item.id,
              label: item.name
            }
          })
        })
      },
      handleFilter() {

        if (this.filter.entityId == undefined) {
          // this.$refs.treeX.setCheckedKeys([])
          this.$alert("请选择运营单位")
          return
        }

        if (this.filter.roleId == undefined) {
          // this.$refs.treeX.setCheckedKeys([])
          this.$alert("请选择角色")
          return
        }

        getMenusByRoleId(this.filter.roleId).then(res => {
          if (res.result != '0') {
            this.$message.error(res.message)
            return
          }
          let menuStr = res.message
          let menus = menuStr.split(",").map(item => {
            return parseInt(item)
          })
          this.$refs.treeX.setCheckedKeys(menus)
          this.expandOrNot(true); //展开权限树菜单
        })
      },

      selectMenuNameFun(menu_data_name,menus) {

        let selectMenuName = true;

        if (menu_data_name.children.length != 0) {
          let arrayCh = [];
          for (const menu_data_name_children of menu_data_name.children) {

            arrayCh.push(menu_data_name_children.id);
          }

          for (const menuCh of menus) {

            let index = arrayCh.indexOf(menuCh);
            if (index != -1) {
              selectMenuName = false;

            }
          }

        } else {

          selectMenuName = false;
        }

        return selectMenuName;
      },

      handleSubmit() {
        if (this.filter.roleId == undefined) {
          this.$message({
            message: "请先选择一个角色",
            type: 'info'
          })
          return
        }

        // this.$confirm('请确认所有权限', '提示', {
        //   confirmButtonText: '确定',
        //   cancelButtonText: '取消',
        //   type: 'warning'
        // }).then(() => {

        let menus = this.$refs.treeX.getCheckedKeys();

        for (const menu of menus) {

          let selectMenuName = true;

          for (const menu_data_name of this.menu_data) {

            if (menu == menu_data_name.id) {

              selectMenuName = this.selectMenuNameFun(menu_data_name,menus);

            } else {
              
              for (const menu_data_ch of menu_data_name.children) {

                if (menu == menu_data_ch.id) {

                  selectMenuName = this.selectMenuNameFun(menu_data_ch,menus);

                }
              }

            }

          } // 循环做菜单栏

          if (selectMenuName) {
            this.$message({
              message: "根节点:请选择一个子菜单",
              type: 'error'
            })
            return
          }

        }

        if (menus.length == 0) {
          this.$message({
            message: "请先选择一个菜单",
            type: 'error'
          })
          return
        }

        let role = {
          id: this.filter.roleId,
          menuItems: menus.join(",")
        }
        updateRoleMenu(role).then(res => {
          if (res.result === "0") {
            this.$message({
              message: res.message,
              type: 'success'
            })
            this.handleFilter()
          } else {
            this.$message.error(res.message)
          }
        })
        // })
      },
      /**
       * 数据初始化
       */
      handleInit() {
        this.initEntityOptions()
        this.initMenuTree()
      },


    },
    mounted() {
      this.initEntityOptions()
      this.initMenuTree()
    }
  }
</script>

<style>
  .el-tree-node__content {
    /* background: #F5F8FA; */
    height: 50px;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    height: 40px;
    padding-left: 10px;
  }

  .menu-tree {
    width: 95%;
    padding-bottom: 50px;
  }
</style>
